import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Mail, Phone, MapPin } from 'lucide-react';

const Contact = () => {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20">
        {/* Title */}
        <h1
          className={`text-4xl md:text-5xl font-bold text-gray-900 mb-12 text-center transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {t('contactTitle')}
        </h1>

        {/* Contact Information */}
        <div
          className={`mb-10 transition-all duration-1000 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-xl font-semibold text-gray-900 mb-6 text-center">
            {t('contactInfo')}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            <div className="flex flex-col items-center text-center group">
              <div className="p-3 bg-gray-100 rounded-lg group-hover:bg-gray-700 group-hover:text-white transition-colors mb-3">
                <Phone className="w-5 h-5" />
              </div>
              <p className="text-sm text-gray-500 mb-1">{t('phone')}</p>
              <a
                href="tel:+358405066025"
                className="text-gray-900 hover:text-gray-600 font-medium transition-colors text-sm"
              >
                +358 40 5066025
              </a>
            </div>

            <div className="flex flex-col items-center text-center group">
              <div className="p-3 bg-gray-100 rounded-lg group-hover:bg-gray-700 group-hover:text-white transition-colors mb-3">
                <Mail className="w-5 h-5" />
              </div>
              <p className="text-sm text-gray-500 mb-1">{t('email')}</p>
              <a
                href="mailto:valokuvaaja@jussinukari.com"
                className="text-gray-900 hover:text-gray-600 font-medium transition-colors text-sm"
              >
                valokuvaaja@jussinukari.com
              </a>
            </div>

            <div className="flex flex-col items-center text-center group">
              <div className="p-3 bg-gray-100 rounded-lg group-hover:bg-gray-700 group-hover:text-white transition-colors mb-3">
                <MapPin className="w-5 h-5" />
              </div>
              <p className="text-sm text-gray-500 mb-1">{t('location')}</p>
              <p className="text-gray-900 font-medium text-sm">
                Helsinki, Finland
              </p>
            </div>
          </div>
        </div>

        {/* Direct email link */}
        <div
          className={`transition-all duration-1000 delay-400 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="bg-white rounded-lg shadow-lg p-8 text-center">
            <h2 className="text-xl font-semibold text-gray-900 mb-4 text-center">
              {t('getInTouch')}
            </h2>
            <p className="text-gray-600 mb-6">
              Laita viesti suoraan sähköpostiin.
            </p>
            <a
              href="mailto:valokuvaaja@jussinukari.com?subject=Yhteydenottolomake"
              className="inline-block bg-gray-900 text-white px-6 py-3 rounded-lg font-medium hover:bg-gray-800 transition-all duration-300"
            >
              valokuvaaja@jussinukari.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;